import { render } from "./ProdutoListagem.vue?vue&type=template&id=75a34a86&ts=true"
import script from "./ProdutoListagem.vue?vue&type=script&lang=ts"
export * from "./ProdutoListagem.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__